// src/components/StockSummary9MPage.jsx
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import useEscapeToGoBack from "../hooks/useEscapeToGoBack";
import "./Renew.css";

const API_URL =
  "https://www.lianfoong.com/api/pawn-transactions/stock-summary-9m";

const pad2 = (n) => String(n).padStart(2, "0");
const currentMMYY = () => {
  const d = new Date();
  return `${pad2(d.getMonth() + 1)}${String(d.getFullYear()).slice(-2)}`;
};

export default function StockSummary9MPage() {
  useEscapeToGoBack();
  const navigate = useNavigate();
  const inputRef = useRef(null);

  const [mmyy, setMmyy] = useState(currentMMYY());
  const [downloading, setDownloading] = useState(false);

  useEffect(() => {
    requestAnimationFrame(() => {
      inputRef.current?.focus();
      inputRef.current?.select?.();
    });
  }, []);

  const onlyDigits = (s) => s.replace(/\D/g, "");
  const normalize = (s) => {
    const d = onlyDigits(s).slice(0, 4);
    return d.length === 3 ? `0${d}` : d;
  };

  const downloadBlob = (blob, filename) => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.setAttribute("download", filename);
    document.body.appendChild(a);
    a.click();
    URL.revokeObjectURL(url);
    a.remove();
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const val = normalize(mmyy);
    if (!/^\d{4}$/.test(val)) {
      alert("Please enter MMYY as 4 digits, e.g. 0425");
      return;
    }

    setDownloading(true);
    try {
      const resp = await axios.get(API_URL, {
        params: { mmyy: val },
        responseType: "blob",
        validateStatus: () => true,
      });

      const ct = resp.headers?.["content-type"] || "";
      if (resp.status >= 400 || ct.includes("text/plain")) {
        const msg =
          typeof resp.data?.text === "function"
            ? await resp.data.text()
            : "Failed to generate report.";
        alert(msg || "Failed to generate report.");
        return;
      }

      downloadBlob(resp.data, `stock_summary_9m_${val}.pdf`);
    } catch (err) {
      console.error(err);
      alert("Error generating report.");
    } finally {
      setDownloading(false);
    }
  };

  const shiftMonth = (delta) => {
    const mm = parseInt(mmyy.slice(0, 2) || "1", 10);
    const yy = parseInt(mmyy.slice(2) || "25", 10) + 2000;
    const d = new Date(yy, mm - 1 + delta, 1);
    const v = `${pad2(d.getMonth() + 1)}${String(d.getFullYear()).slice(-2)}`;
    setMmyy(v);
  };

  return (
    <div className="renew-container">
      <h2 className="title">Stock Summary</h2>

      <form onSubmit={onSubmit}>
        <div className="form-group">
          <label>MMYY (e.g. 0425)</label>
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <button type="button" className="search-btn" onClick={() => shiftMonth(-1)}>
              ◀
            </button>
            <input
              ref={inputRef}
              type="text"
              inputMode="numeric"
              pattern="\d{4}"
              maxLength={4}
              value={mmyy}
              onChange={(e) => setMmyy(onlyDigits(e.target.value).slice(0, 4))}
              onBlur={(e) => setMmyy(normalize(e.target.value))}
              placeholder="MMYY"
              required
              style={{ width: 120, textAlign: "center" }}
            />
            <button type="button" className="search-btn" onClick={() => shiftMonth(1)}>
              ▶
            </button>
          </div>
        </div>

        <button className="search-btn" type="submit" disabled={downloading}>
          {downloading ? "Generating…" : "Generate PDF"}
        </button>

        <button
          type="button"
          className="next-btn"
          onClick={() => navigate(-1)}
          style={{ marginTop: 10 }}
        >
          Back
        </button>
      </form>
    </div>
  );
}
